import { ReactComponent as HomeIcon } from "@/assets/icons/home.svg";
import { ReactComponent as InventoryIcon } from "@/assets/icons/inventory.svg";
import { ReactComponent as NewsIcon } from "@/assets/icons/news.svg";
import { ReactComponent as NotificationIcon } from "@/assets/icons/notification.svg";
import { ReactComponent as OrderIcon } from "@/assets/icons/orders.svg";
import { ReactComponent as ProductIcon } from "@/assets/icons/product.svg";
import { ReactComponent as SettingsIcon } from "@/assets/icons/settings.svg";
import { ReactComponent as TradeIcon } from "@/assets/icons/trade.svg";
import { ReactComponent as UsersIcon } from "@/assets/icons/users.svg";
import { ReactComponent as ChevronDownIcon } from "@/assets/icons/chevron-down.svg";
import { MenuValue, SidebarMenuItem } from "../model";
import { FC } from "react";
import "./style.scss";

interface MenuItemPropTypes {
  activeMenu: MenuValue;
  menuItem: SidebarMenuItem;
  onClickMenu: (value: MenuValue, path: string) => void;
}

const MenuItem: FC<MenuItemPropTypes> = ({
  activeMenu,
  menuItem,
  onClickMenu,
}) => {
  const { value, label, path, subMenus } = menuItem;

  const getIcons = (menuValue: MenuValue) => {
    switch (menuValue) {
      case "dashboard":
        return <HomeIcon />;
      case "products":
        return <ProductIcon />;
      case "trade":
        return <TradeIcon />;
      case "inventory":
        return <InventoryIcon />;
      case "orders":
        return <OrderIcon />;
      case "news":
        return <NewsIcon />;
      case "notification":
        return <NotificationIcon />;
      case "users":
        return <UsersIcon />;
      case "settings":
        return <SettingsIcon />;
    }
  };

  return (
    <div
      className={"menu-item" + (activeMenu === value ? " active" : "")}
      key={value}
      onClick={() => onClickMenu(value, path)}
    >
      {getIcons(value)}
      <label className="menu-label">{label}</label>
      <div className="submenu-btn">
        {subMenus.length !== 0 && <ChevronDownIcon />}
      </div>
    </div>
  );
};

export default MenuItem;
